import { useMsal } from "@azure/msal-react";
import { useQuery } from "@tanstack/react-query";
import { Link, NavLink } from "react-router-dom";
import LiaiseWordmark from "../brand/LiaiseWordmark";
import { api } from "../api/client";

function NavItem({ to, label, badge }: { to: string; label: string; badge?: number }) {
  return (
    <NavLink
      to={to}
      end={to === "/"}
      className={({ isActive }) =>
        `flex items-center gap-2 px-3 py-1.5 rounded-full text-sm transition ${
          isActive ? "bg-white/15 text-white font-semibold" : "text-white/75 hover:text-white"
        }`
      }
    >
      {label}
      {badge != null && badge > 0 && (
        <span className="bg-liaise-yellow text-liaise-navy text-xs font-bold px-1.5 py-0.5 rounded-full min-w-[18px] text-center">
          {badge}
        </span>
      )}
    </NavLink>
  );
}

export default function AppShell({ children }: { children: React.ReactNode }) {
  const { instance, accounts } = useMsal();
  const account = accounts[0];
  const { data: me } = useQuery({ queryKey: ["me"], queryFn: api.me });

  return (
    <div className="min-h-screen flex flex-col">
      <header className="bg-liaise-navy text-white">
        <div className="max-w-6xl mx-auto px-6 py-3 flex items-center justify-between gap-4">
          <div className="flex items-center gap-3 shrink-0">
            <Link to="/">
              <LiaiseWordmark className="h-7 w-auto" />
            </Link>
            <span className="text-white/40 hidden sm:inline">|</span>
            <span className="font-medium hidden sm:inline">Recruitment Assessment</span>
          </div>
          <nav className="flex items-center gap-1 flex-wrap justify-end">
            <NavItem to="/" label="Assessments" />
            <NavItem to="/new" label="New" />
            <NavItem to="/evaluate" label="Evaluate" badge={me?.pending_evaluations} />
            {me?.sees_all && <NavItem to="/audit" label="Audit" />}
            {me?.is_admin && <NavItem to="/admin" label="Admin" />}
          </nav>
          <div className="text-sm flex items-center gap-3 shrink-0">
            <span className="text-white/80 hidden md:inline">{account?.name ?? account?.username}</span>
            <button
              onClick={() => instance.logoutRedirect()}
              className="text-white/80 hover:text-white underline-offset-4 hover:underline"
            >
              Sign out
            </button>
          </div>
        </div>
      </header>

      <main className="flex-1 max-w-6xl mx-auto w-full px-6 py-8">{children}</main>

      <footer className="border-t border-slate-200 py-4 text-center text-sm text-slate-500">
        Your goals are our goals.
      </footer>
    </div>
  );
}
